import React from "react";
import { FinalDataOrganism } from "../../organisms";

export const FinalDataPage: React.FC = () => {
  return <FinalDataOrganism />
};
